export default __webpack_public_path__ + "static/media/2582.95325f83.png";